import React, {ReactElement, useEffect, useState} from "react";
import {useAppSelector} from "../../../store/hook";
import DashboardLoading from "./DashboardLoading";
import {MgResourceModel} from "../../../model/common/mgResourceModel";
import DashboardNoData from "./DashboardNoData";
import {parseNumberWithComma} from "../../../utils/stringUtil";
import DashboardCard from "./DashboardCard";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";

export default function FlexResource(props: Readonly<DashboardModuleProps>) {
  const mgResources = useAppSelector((state) => state.mgResource.mgResources);
  const hasFlexResource = useAppSelector((state) => state.mgResource.hasFlexResource);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [flexPvList, setFlexPvList] = useState<MgResourceModel[]>();
  const [flexEssList, setFlexEssList] = useState<MgResourceModel[]>();
  const [flexFacilityList, setFlexFacilityList] = useState<MgResourceModel[]>();
  const [supplyTotalCapa, setSupplyTotalCapa] = useState<number>(0);
  const [loadTotalCapa, setLoadTotalCapa] = useState<number>(0);

  useEffect(() => {
    const flexResources = mgResources.filter(r => r.flxRsrcYn === 'Y');

    if (flexResources && flexResources.length > 0) {
      let supplyTotalCapa = 0;
      let loadTotalCapa = 0;
      const flexPvList = flexResources.filter(r => r.emksRsrcClCd === 1);
      const flexEssList = flexResources.filter(r => r.emksRsrcClCd === 22);
      const flexFacilityList = flexResources.filter(r => r.emksRsrcClCd === 23);

      flexPvList.forEach((r => supplyTotalCapa += r.mgRsrcCpct));
      flexEssList.forEach((r => supplyTotalCapa += r.mgRsrcCpct));
      flexFacilityList.forEach((r => loadTotalCapa += r.mgRsrcCpct));

      setFlexPvList(flexPvList);
      setFlexEssList(flexEssList);
      setFlexFacilityList(flexFacilityList);
      setSupplyTotalCapa(supplyTotalCapa);
      setLoadTotalCapa(loadTotalCapa);
    }

    setIsLoading(false);
  }, [mgResources])

  function creatFlexResourceLi(resource: MgResourceModel): ReactElement {
    let iconClassName = 'b-t-icon8';

    if (resource.emksRsrcClCd === 1) {
      iconClassName = 'b-t-icon1';
    } else if (resource.emksRsrcClCd === 22) {
      iconClassName = 'b-t-icon6'
    }

    return (
      <li key={resource.mgRsrcId}>
        <span className="img-t"><em className={iconClassName}></em>{resource.mgRsrcNm}</span>
        <span className="txt"><strong>{resource.mgRsrcCpct}</strong> kW</span>
      </li>
    );
  }

  return (
    <DashboardCard
      title="유연자원 보유 현황"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/pc/facility/status"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading}/>
      {/*{!isLoading && !hasFlexResource ? (*/}
      {/*    <DashboardNoData message="등록된 유연자원이 없습니다." />*/}
      {/*) : (*/}
        <div className="box-table-wrap">
          <div className="box-table">
            <p className="tit">공급 유연자원</p>
            <div className="box"><span><strong>{parseNumberWithComma(supplyTotalCapa)}</strong>kW</span></div>
            <div className="table">
              <ul>
                <>
                  {flexPvList?.map((r) => creatFlexResourceLi(r))}
                  {flexEssList?.map((r) => creatFlexResourceLi(r))}
                </>
              </ul>
            </div>
          </div>
          <div className="box-table">
            <p className="tit">부하 유연자원</p>
            <div className="box"><span><strong>{parseNumberWithComma(loadTotalCapa)}</strong>kW</span></div>
            <div className="table">
              <ul>
                <>
                  {flexFacilityList?.map((r) => creatFlexResourceLi(r))}
                </>
              </ul>
            </div>
          </div>
        </div>
      {/*)}*/}
    </DashboardCard>
  );
}